var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',[_c('app-banner'),_c('com-filter',{on:{"change":_vm.onFilterChange}}),_c('com-feed',{attrs:{"items":_vm.feed,"loading":_vm.loading}}),(_vm.total > _vm.feed.length)?_c('com-paginate',{attrs:{"current":_vm.page,"total":_vm.total,"loading":_vm.loading},on:{"click":_vm.onPaginate}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }